<template>
  <div>
    <tabs :tabs="tabs"></tabs>
  </div>
</template>

<script>
import Tabs from "./Components/Tabs";
import IeltsOverall from "./IeltsOverall";
import ToeflOverall from "./ToeflOverall";
import SMI from "./SMI";
import SRI from "./SRI";
export default {
  components: { Tabs },
  data() {
    const tabs = [
      {
        name: "ielts-overall",
        label: "IELTS",
        component: IeltsOverall
      },
      {
        name: "toefl-overall",
        label: "TOEFL",
        component: ToeflOverall
      },
      {
        name: "sri",
        label: "SRI",
        component: SRI
      },
      {
        name: "smi",
        label: "SMI",
        component: SMI
      }
    ];
    return {
      tabs
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine";

.tab-button {
  @apply py-2 px-4;
  @apply text-gray-500 font-medium;
  @apply cursor-pointer;
  @apply outline-none;

  font-size: 1rem;

  &.active {
    border-top: 2px solid md-get-palette-color(purple, 500);
  }
}
</style>
